var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelivery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 34 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 16.667L27 0 10.334 5l5 16.667 16.666-5zM25.884 2.083l4.033 13.467-13.467 4.033-4.033-13.466 13.467-4.034zM1.2 13.883h3.333a.834.834 0 000-1.666H1.2a.85.85 0 00-.833.833.833.833 0 00.833.833zM1.167 18.883h5a.834.834 0 000-1.666h-5a.834.834 0 000 1.666zM7.867 22.217H1.2a.834.834 0 000 1.666h6.667a.834.834 0 000-1.666z",
    fill: "#1998D5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.667 20.6a.833.833 0 00-1.034-.567l-16.15 4.85a3.333 3.333 0 00-2.816-1.55h-.2L7 2.25C6.2 0 4.567 0 2.833 0a.833.833 0 100 1.667c1.667 0 2.184 0 2.55 1.1l6.484 21.1a3.333 3.333 0 001.8 6.133c.344 0 .687-.051 1.017-.15a3.333 3.333 0 002.3-3.333l16.083-4.85a.835.835 0 00.6-1.067zm-19.5 7.733a1.663 1.663 0 01-.5 0 1.666 1.666 0 010-3.333 1.685 1.685 0 11.5 3.333z",
    fill: "#1998D5"
  })));
}
export default SvgDelivery;